import React, { useState } from 'react';
import {  ClickAwayListener } from '@mui/material';
import { styled } from '@mui/material/styles';
import infoIcon from "../../../assets/images/icons/info-icon.svg"
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const HtmlTooltipForDetails = ({ children,trigger = null, ...props }) => {
    const [open, setOpen] = useState(false);
    
    /**
     * Toggles or sets the state of the tooltip.
     *
     * @param {boolean|null} val - The desired state of the tooltip. If `null`, the function toggles the current state. 
     *                             If `true` or `false`, it explicitly sets the state.
     */
    const handleTooltipState = (val = null) => {
        if(val == null) {
            setOpen(!open);
        } else {
            setOpen(val)
        }
    }
    
    /**
     * - The `ClickAwayListener` ensures the tooltip closes when a click occurs outside of it.
     * - The `Tooltip` is styled using the `styled` utility and takes theme-based styles.
     * - Custom styles are applied to the tooltip's popper and content.
     */
    const StyledTooltip = styled(({ className, ...rest }) => (
        <ClickAwayListener onClickAway={()=>{handleTooltipState(false)}}>
            <Tooltip {...rest} classes={{ popper: className }} />
        </ClickAwayListener>
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#f5f5f9',
            color: 'rgba(0, 0, 0, 0.87)',
            fontSize: theme.typography.pxToRem(12),
            border: '2px solid #dadde9',
            PointerEvent:'auto'
        },
    }));


    /**
     * - If `trigger` is `'click'`, the tooltip will open and close only when clicked.
     *   - Listeners for hover, focus, and touch events are disabled.
     *   - Explicit open and close handlers (`handleTooltipState`) are provided for managing the tooltip's state.
     *
     * - If `trigger` is not `'click'`, a default `StyledTooltip` is rendered with the provided props and children.
     */
    if (trigger == 'click') {
        return (
                <StyledTooltip
                    {...props}
                    open={open}
                    disableFocusListener
                    // disableHoverListener
                    disableTouchListener
                    onClose={()=>{handleTooltipState(false)}}
                    onOpen={()=>{handleTooltipState(true)}}
                >
                    {children(handleTooltipState)}
                </StyledTooltip>
        );
    } else {
        return <StyledTooltip {...props}>{children}</StyledTooltip>;
    }

};

export default HtmlTooltipForDetails;
